import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const ReportingStyle = makeStyles({
  ReportingWrapper: {
    boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
    backgroundColor: colors.white,
    borderRadius: 6,
    marginTop: 25,
  },
  customBox: {
    border: "1px solid #e7e4f1",
    borderRadius: 6,
    padding: 40,
    "& .primary-btn": {
      fontSize: 16,
      minWidth: 165,
      fontWeight: 600,
      lineHeight: "50px",
      textTransform: "uppercase",
      height: 50,
      "&:hover": {
        boxShadow: "none",
        color: "default",
        backgroundColor: "transparent",
      },
    },
    "& .chip-input": {
      "& > div": {
        minHeight: 50,
        border: "1px solid #e7e4f1",
        marginBottom: 0,
        borderRadius: 6,
        alignItems: "center",
        padding: "10px 15px 0",
        overflow: "hidden",
        "&::before": {
          display: "none",
        },
        "&::focus": {
          border: "none",
        },
        "& input": {
          border: "none",
          padding: "0 !important",
        },
      },
      "& .MuiChip-root": {
        height: 28,
        lineHeight: "28px",
        backgroundColor: colors.lightGraybg,
        fontSize: 16,
        color: colors.black,
        borderRadius: 30,
      },
      "& .MuiInput-root": {
        marginTop: "-10px",
        "& input": {
          height: 38,
          lineHeight: "38px",
        },
      },
    },
    "& .header": {
      "& .MuiTypography-root": {
        fontSize: 24,
        fontWeight: "bold",
        lineHeight: 1,
      },
      "& span": {
        verticalAlign: "middle",
      },
      "& .switch": {
        float: "right",
        verticalAlign: "middle",
        marginLeft: 0,
        "@media (max-width: 575px)": {
          float: "none",
          display: "block",
          marginLeft: 10,
          marginTop: 10,
        },
      }
    },
    "& .content": {
      paddingTop: 35,
      "& .error-text": {
        color: colors.red,
      },
      "& .emails": {
        "& .title": {
          marginBottom: 10,
        },
        "& .tip": {
          color: colors.gray1,
          fontSize: 15,
        }
      },
      "& .frequency": {
        marginTop: 30,
        "& .title": {
          marginBottom: 5,
        },
        "& .box-container": {
          "& .box-holder": {
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            maxWidth: 800,
            "@media (max-width: 767px)": {
              display: "block"
            },
            "& .box": {
              flex: 1,
              "& .MuiTypography-root": {
                fontSize: 16
              },
              "& .error-holder": {
                "& img": {
                  border: "1px dashed red",
                }
              }
            }
          },
        }
      },
      "& button": {
        marginTop: 30,
        marginRight: 0,
        marginLeft: "auto",
      }
    }
  },
})

export {ReportingStyle};